import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MicroServiceService } from '../services/micro-service.service';

@Component({
  selector: 'app-micro-service-form',
  templateUrl: './micro-service-form.component.html',
  styleUrls: ['./micro-service-form.component.css']
})
export class MicroServiceFormComponent {

  microserviceId!: string;

  serviceName: string = '';

  permissions: string[] = [];
  groupedPermissions: { [scope: string]: string[] } = {};

  loading = true;

  constructor(
    private route: ActivatedRoute,
    private microServiceService: MicroServiceService
  ) { }

  ngOnInit(): void {
    this.microserviceId = this.route.snapshot.paramMap.get('id')!;
    this.loadMicroservicePermissions();
  }

  // --------------------------------------------------
  // Load & classify permissions by scope
  // --------------------------------------------------
  loadMicroservicePermissions() {
    this.loading = true;

    this.microServiceService
      .getMicroservicePermissions(this.microserviceId)
      .subscribe({
        next: (res: any) => {

          // Backend returns: { serviceName, permissions, count }
          this.serviceName = res?.serviceName || '';
          this.permissions = res?.permissions || [];

          this.groupPermissionsByScope();
          this.loading = false;
        },
        error: (err) => {
          console.error('Failed to load microservice permissions', err);
          this.loading = false;
        }
      });
  }

  // --------------------------------------------------
  // Group permissions by scope prefix
  // --------------------------------------------------
  private groupPermissionsByScope() {
    this.groupedPermissions = {};

    this.permissions.forEach(permission => {
      const scope = permission.split('.')[0]; // system, project, role, self, ...

      if (!this.groupedPermissions[scope]) {
        this.groupedPermissions[scope] = [];
      }

      this.groupedPermissions[scope].push(permission);
    });

    // Optional: sort permissions inside each scope
    Object.keys(this.groupedPermissions).forEach(scope => {
      this.groupedPermissions[scope].sort();
    });
  }

  // Helper for template iteration
  get scopes(): string[] {
    return Object.keys(this.groupedPermissions);
  }
}
